import { useMe } from '@/app/MeProvider';
import { useRuntimeConfig } from '@/config/ConfigProvider';

/**
 * The app-wide footer: copyright, the build's version and commit, which environment
 * this is, and a short note when Mercury is not the live feed. It spans the whole
 * viewport below the sidebar and scroll pane, so it stays fixed while pages scroll.
 */
export function AppFooter({ year = new Date().getFullYear() }: { year?: number }) {
  const { environment } = useRuntimeConfig();
  const mercury = useMe()?.features.mercury;
  return (
    <footer className="flex shrink-0 flex-wrap items-center justify-between gap-x-4 gap-y-1 border-t bg-background px-4 py-2 text-xs text-muted-foreground sm:px-6">
      <span>© {year} Albuelis, Inc.</span>
      <span className="flex flex-wrap items-center gap-x-1.5">
        <span>
          v{__APP_VERSION__} ({__APP_COMMIT__}) · <span className="font-medium">{environment}</span>
        </span>
        {mercury && mercury !== 'live' ? (
          <span className="font-medium text-warning">
            · {mercury === 'fixture' ? 'Mercury fixture data' : 'Mercury sandbox data'}
          </span>
        ) : null}
      </span>
    </footer>
  );
}
